import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-mall-sim",
  "use": "icon-soc-l1-mall-sim-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-mall-sim\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\">\r\n  <path d=\"M288 160h448a64 64 0 0 1 64 64v576a64 64 0 0 1-64 64H288a64 64 0 0 1-64-64V224a64 64 0 0 1 64-64zm48 96v512h352V256H336zm64 64h224v48H400v-48zm0 96h224v48H400v-48zm0 96h160v48H400v-48z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-mall-sim.svg
// module id = mIiw
// module chunks = 546